<script>
import SelectAnswer from "../framework/SelectAnswer";

import answerMixin from "@mixin/answer.mixin";

export default {
    name: "SelectAnswerComponent",
    mixins: [answerMixin],
    methods: {
        compare(instance) {
            return instance instanceof SelectAnswer;
        },
    },
};
</script>

<template>
    <v-select v-if="state" v-model="value" outlined persistent-hint item-text="key" item-value="value" v-bind="attrs" />
</template>

<style lang="scss" scoped></style>
